import { useState } from "react";

export function useUpdateProfile() {
    const [firstName, setFirstName] = useState('');
    const [middleName, setMiddleName] = useState('');
    const [lastName, setLastName] = useState('');
    const [code, setCode] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [image, setImage] = useState('');
    const [birthDate, setBirthDate] = useState('');
    const [majorId, setMajorId] = useState('');
    const [academicDegreeId, setAcademicDegreeId] = useState('');

    return {
        firstName, setFirstName, middleName, setMiddleName, lastName, setLastName,
        code, setCode, phoneNumber, setPhoneNumber, image, setImage, birthDate, setBirthDate,
        majorId, setMajorId, academicDegreeId, setAcademicDegreeId,
    };
}
